import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class BankaBilgileriAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "BankaBilgileri";
        super(baseUrl);
    }

    getBankaBilgileri() {
        return this.get();
    }

    updateBankaBilgileri(otpRequest: BankaBilgileriGuncelleRequest) {
        return this.post("GuncelleBankaBilgileri", otpRequest);
    }

}
export default new BankaBilgileriAPI();

class BankaBilgileriGuncelleRequest {
  id?: number;            
  bankaAdi?: string;    
  bankaKodu?: string;    
  uyeNo?: string;   
  posNo?: string;   
  sifre?: string;
  posnetUrl?: string;     
  posnetXmlUrl?: string;
  basariliUrl?: string;   
  basarisizUrl?: string; 
  islem3D?: string;    
  vezneKodu?: number;     
  aktifEh?: string;      
  taksitSayisi?: number;  
  vadeFarkliMi?: string;  
  anlasmaliMi?: string;  
  kurumAdi?: string;      
  kullaniciKodu?: string;
  guvenlikKodu?: string;  
  odemeYontemi3D?: string;

  constructor(init?: Partial<BankaBilgileriGuncelleRequest>) {
    Object.assign(this, init);
  }
}
export { BankaBilgileriGuncelleRequest };